/**
 * Convert a base64 string (no data URL prefix) to a Uint8Array of bytes.
 * Browser first (atob), with Node/SSR fallback.
 */
export function base64ToBytes(b64: string): Uint8Array {
  if (!b64) return new Uint8Array();
  if (typeof atob === 'function') {
    const binary = atob(b64);
    const out = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) out[i] = binary.charCodeAt(i);
    return out;
  }
  return new Uint8Array(Buffer.from(b64, 'base64'));
}
